class BusinessEntity {
	constructor({uuid, name, informations, address}) {
		this.uuid = uuid;
		this.name = name || '';
		this.mailTo = informations?.mailto || '';
		this.address = address || '';
	}
}

class OrganizationInfoTicket {
	constructor({id, name, business_entity: businessEntity}) {
		this.id = id;
		this.name = name || '';
		this.businessEntity = new BusinessEntity(businessEntity);
	}

	getKey() {
		return this.id;
	}
}
export default OrganizationInfoTicket;
